<template>
    <div class="contact-header">
        <img class="contact-header-img contact-header" src="../../static/image/contact/contact-header.jpg">
        <el-row>
            <el-col :span="16" :offset="4">
                <div class="contact-header-T" v-if="contact==null">上海索康医用材料有限公司</div>
                <div class="contact-header-T" v-else>{{contact.name}}</div>
                <el-col :span="8">
                    <div class="content-box">
                        <div>
                            <div class="content-text">
                                <img class="content-icon" src="../../static/image/contact/contact-icon01.png">
                                <div v-if="contact==null">上海市绥德路613弄2号楼</div>
                                <div v-else>{{contact.address}}</div>
                            </div>
                            <div class="content-text">
                                <img class="content-icon" src="../../static/image/contact/contact-icon02.png">
                                <div v-if="contact==null">( 86 )&nbsp - 21 - 66082766</div>
                                <div v-else>{{contact.phone}}</div>
                            </div>
                            <div class="content-text">
                                <img class="content-icon" src="../../static/image/contact/contact-icon04.png">
                                <div v-if="contact==null">( 86 )&nbsp - 21 - 66082138</div>
                                <div v-else>{{contact.fax}}</div>
                            </div>
                            <div class="content-text">
                                <img class="content-icon" src="../../static/image/contact/contact-icon03.png">
                                <div v-if="contact==null">www . surgithes . com</div>
                                <div v-else>{{contact.websiteUrl}}</div>
                            </div>
                            <div class="content-text">
                                <img class="content-icon" src="../../static/image/contact/contact-icon05.png">
                                <div v-if="contact==null">sk_admin@suokangsh.com.cn</div>
                                <div v-else>{{contact.email}}</div>
                            </div>
                        </div>
<!--                        <div class="content-boxs">-->
<!--                            <div class="content-B">-->
<!--                                <img class="content-EWM" src="../../static/image/main/mainWX1.png">-->
<!--                                <div>关注微信</div>-->
<!--                            </div>-->
<!--                            <div class="content-B">-->
<!--                                <img class="content-EWM" src="../../static/image/main/mainWX02.png">-->
<!--                                <div>关注微博</div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                </el-col>
                <el-col :span="16">
                    <img  v-if="contact==null" class="contact-header-img" src="../../static/image/contact/contact-map.png">
                    <img  v-else class="contact-header-img" :src="contact.mapImage">
                </el-col>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      contact: null
    }
  },
  metaInfo: {
    title: '联系我们', // set a title
    meta: [{                 // set meta
      name: 'keyWords',
      content: '索康联系'
    }],
    link: [{                 // set link
      rel: 'description',
      content: '这是索康的官网的联系方式'
    }]
  },
  created() {
    // 创建时执行跳转锚点位置
    this.$nextTick(() => {
      // console.log(findId)
      this.$store.dispatch('method/anchorPoint', 'header')
    })
    this.$store.dispatch('contact/concatMessage').then((res) => {
      // this.newsList = res
      this.contact = res
      // console.log(res)
    })
  },
}
</script>

<style scoped>
    .contact-header-img {
        width: 100%;
    }

    .contact-header {
        margin-bottom: 80px;
    }

    .contact-header-T {
        font-size: 24px;
        font-family: SY-Normal;
        color: #430098;
        width: 100%;
        height: 70px;
        border-bottom: 1px solid #430098;
        margin-bottom: 80px;
    }

    .content-icon {
        width: 23px;
        height: 23px;
        margin-right: 20px;
    }

    .content-text {
        font-family: SY-Normal;
        font-size: 17px;
        color: #606060;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 25px;
    }

    .content-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
    }

    .content-boxs {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-top: 130px;
        font-family: SY-Light;
        font-size: 15px;
        color: #606060;
    }

    .content-B {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 30px;
    }

    .content-EWM {
        width: 100px;
        height: 100px;
        margin-bottom: 21px;
    }
</style>
